// 계정 보너스 종류별 상한 (PRD 4.7, 계약 1.4). 도감·연합·펫 세 출처의 합이 아무리 커도 이 표를 넘지 않는다.
// 시험이 표의 값 자체를 단언한다. 순수·할당 없음(out 인자).
import { ACCOUNT_BONUS_KEYS, type AccountBonusIn, type Mutable } from './bonus';

/** 출처별 열 최대(표 그대로). 표에 없는 칸은 0 = 그 출처는 그 종류를 주지 않는다 */
export const SOURCE_CAP: { readonly codex: AccountBonusIn; readonly union: AccountBonusIn; readonly pet: AccountBonusIn } = Object.freeze({
  codex: Object.freeze({ atkPct: 0.045, hpPct: 0.05, crit: 0.01, gold: 0.05, drop: 0.03, xp: 0.03, damageTaken: 0, hpRegen: 0 }),
  union: Object.freeze({ atkPct: 0.048, hpPct: 0.072, crit: 0.024, gold: 0.072, drop: 0.072, xp: 0.072, damageTaken: 0, hpRegen: 0 }),
  pet: Object.freeze({ atkPct: 0, hpPct: 0, crit: 0.03, gold: 0.08, drop: 0.12, xp: 0.08, damageTaken: 0.04, hpRegen: 0.005 }),
});
/** 세 출처 합 상한(계정 보너스 상한): 공격 12%·HP 15%·치명 7%p·받는 피해 감소 4%·골드 20%·드롭 22%·EXP 18%·HP 재생 0.5%/초 */
export const ACCOUNT_BONUS_CAP: AccountBonusIn = Object.freeze({ atkPct: 0.12, hpPct: 0.15, crit: 0.07, gold: 0.20, drop: 0.22, xp: 0.18, damageTaken: 0.04, hpRegen: 0.005 });

/** 음수·NaN → 0, 상한 초과 → 상한(Infinity도 상한) */
function clampTo(v: number, cap: number): number { return v > 0 ? (v < cap ? v : cap) : 0; }

/**
 * 출처별로 자기 열 상한에 자른 뒤 더하고, 합을 ACCOUNT_BONUS_CAP으로 한 번 더 자른다. out에 써서 돌려준다(할당 없음).
 * out이 입력과 같은 객체여도 키마다 먼저 읽고 쓰므로 안전하다.
 */
export function sumAccountBonus(codex: AccountBonusIn, union: AccountBonusIn, pet: AccountBonusIn, out: Mutable<AccountBonusIn>): AccountBonusIn {
  for (let i = 0; i < ACCOUNT_BONUS_KEYS.length; i++) {
    const k = ACCOUNT_BONUS_KEYS[i];
    const sum = clampTo(codex[k], SOURCE_CAP.codex[k]) + clampTo(union[k], SOURCE_CAP.union[k]) + clampTo(pet[k], SOURCE_CAP.pet[k]);
    out[k] = clampTo(sum, ACCOUNT_BONUS_CAP[k]);
  }
  return out;
}
